import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '@celepar/header-estado';
import { 
  HomePage, 
  DuvidasPage, 
  NoticiasPage, 
  BibliotecaPage,
  LegislacaoPage,
  DocumentosPage
} from './components/pages';
import { NoticiaPageWrapper } from './components/utils';
import { 
  Footer, 
  // Chatbot, // Temporariamente desativado
  Layout,
  HeaderEstadual
} from './components/global';

function App() {
  return (
    <Router basename="/site">
      <div className="App">
        {/* Header do Estado do Paraná */}
        <HeaderEstadual />
        
        {/* Layout com NavBar e conteúdo das páginas */}
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/duvidas" element={<DuvidasPage />} />
            <Route path="/noticias" element={<NoticiasPage />} />
            <Route path="/noticia/:id" element={<NoticiaPageWrapper />} />
            <Route path="/biblioteca" element={<BibliotecaPage />} />
            <Route path="/legislacao" element={<LegislacaoPage />} />
            <Route path="/documento" element={<DocumentosPage />} />
          </Routes>
        </Layout>
        
        <Footer />
        {/* <Chatbot /> */} {/* Temporariamente desativado */}
      </div>
    </Router>
  );
}

export default App;
